import { PassengerLegStatus } from '@eti/schema-types';
import { Stack, Text, textColors } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import AirlineReferenceInfo from '../../common/AirlineReferenceInfo';
import type { TripSegmentType } from '../../../models';
import { getAirlineReferenceEmail } from './utils';
import UploadDocumentsLink from './UploadDocumentsLink';

interface AllPassengersSameStatusCheckInInfoProps {
  checkInStatus: PassengerLegStatus;
  segment: TripSegmentType;
}

const AllPassengersSameStatusCheckInInfo = ({
  checkInStatus,
  segment,
}: AllPassengersSameStatusCheckInInfoProps) => {
  const { t } = useTranslation();
  const { customerDetails, flightInformation } = useOrderDetails();
  const { origin, destination, departuredAt, arrivedAt, carrierBookingNumber } = segment;

  switch (checkInStatus) {
    case PassengerLegStatus.Success:
      return <Text>{t('CheckIn.Purchased.Success.Description')}</Text>;
    case PassengerLegStatus.Pending:
      return <Text>{t('CheckIn.Purchased.Pending.Description')}</Text>;
    case PassengerLegStatus.Suspended:
      return (
        <>
          <Stack spacing={8}>
            <Text>{t('CheckIn.Purchased.MissingDocs.Description')}</Text>
            <UploadDocumentsLink />
          </Stack>
          <Text color={textColors.LIGHTER}>
            {t('CheckIn.Purchased.MissingDocs.Disclaimer.Text')}
          </Text>
        </>
      );
    default:
      return (
        <AirlineReferenceInfo
          airlineReferenceInfo={{
            destination,
            origin,
            arrivedAt,
            departuredAt,
            emailInfo: getAirlineReferenceEmail(
              flightInformation,
              customerDetails.email,
              segment.pnr,
            ),
            carrierBookingNumber,
          }}
          dataTestId="check-in-status-failed-airline-ref-info"
          descriptionContent={<Text>{t('CheckIn.Purchased.Failure.Description')}</Text>}
        />
      );
  }
};

export default AllPassengersSameStatusCheckInInfo;
